import React from "react"
import { Footer } from "./Footer"
import {
  FormContainer,
  Worksheet,
  CheckboxYesNo,
  LabeledInput,
  formatCurrency
} from "uikit"
import { useStore } from "store"
import { Dropdown, Radio, Grid, Checkbox } from "semantic-ui-react"
import { PAY_FREQUENCY_DIVISOR } from "components/incomes/dropDownOptions"

const getOwnerId = (incomes, people, incomeId) => {
  const income = incomes.find(income => income.id === incomeId)
  const owner = income ? people.find(({ id }) => id === income.person_id) : null
  return owner ? owner.id : null
}

const getPeriodDescription = period => {
  let description = ""
  if (period === "annually") {
    description = "once a year"
  } else if (period === "semiannually") {
    description = "twice a year"
  } else if (period === "quarterly") {
    description = "every quarter"
  } else if (period === "monthly") {
    description = "every month"
  } else if (period === "weekly") {
    description = "every week"
  } else if (period === "biweekly") {
    description = "every two weeks"
  } else if (period === "semimonthly") {
    description = "twice a month"
  }
  return description
}
const PeopleCheckboxGroup = ({ people, ownerId, coveredPeople }) => (
  <Grid columns="equal">
    {people.map(person => (
      <Grid.Row textAlign="left" key={person.id} style={{ padding: "0px" }}>
        <Grid.Column>
          <Checkbox
            disabled={person.id === ownerId}
            label={person.first_name}
            checked={
              person.id === ownerId ||
              !!coveredPeople.array.find(
                element => element.fields.person_id.value === person.id
              )
            }
            onChange={(event, eventData) => {
              if (eventData.checked) {
                coveredPeople.append({ person_id: person.id })
              } else {
                coveredPeople.array
                  .find(element => element.fields.person_id.value === person.id)
                  .remove()
              }
            }}
          />
        </Grid.Column>
      </Grid.Row>
    ))}
  </Grid>
)

const ESHCPlanForm = ({
  data: {
    fields: {
      income_id,
      premium_amount,
      people_coverage,
      covered_people,
      is_hdhp,
      employer_hsa_contribution_amount,
      hsa_account_id
    },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Done",
  submitHeader = "",
  isNew,
  onDelete,
  incomes,
  accounts,
  people,
  employers,
  accountOptionFilters,
  incomeSourceOptions,
  getAnnualCost
}) => {
  let ownerId = getOwnerId(incomes, people, income_id.value)
  const hsaAccountOptions = accounts
    .filter(accountOptionFilters.hsaAccount(accounts, ownerId))
    .map(account => ({
      text: account.name,
      value: account.id
    }))
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row
          label="Which employment provides this healthcare plan?"
          paddedField
        >
          <Worksheet.Field error={income_id.error}>
            <Dropdown
              {...income_id}
              options={incomeSourceOptions}
              placeholder="Employment"
              selection
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="What is the premium you pay each pay period?"
          paddedField
        >
          <Worksheet.Field error={premium_amount.error}>
            <LabeledInput
              {...premium_amount}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
            <div style={{ fontWeight: "normal" }}>
              {getAnnualCost(premium_amount.value, income_id.value)}
            </div>
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="Who is covered by this health plan?" paddedField>
          <Worksheet.Field>
            <div className="WorksheetField__RadioGroup">
              <Radio
                label="Just Me"
                name={people_coverage.name}
                checked={people_coverage.value === "individual"}
                onChange={() => {
                  people_coverage.onChange(null, { value: "individual" })
                  covered_people.clear()
                }}
              />
              <br />
              <Radio
                label="Family"
                name={people_coverage.name}
                checked={people_coverage.value === "family"}
                onChange={() => {
                  people_coverage.onChange(null, { value: "family" })
                  covered_people.clear()
                }}
              />
              <br />
              <Radio
                label="Other"
                name={people_coverage.name}
                checked={people_coverage.value === "other"}
                onChange={() => {
                  people_coverage.onChange(null, { value: "other" })
                }}
              />
            </div>
          </Worksheet.Field>
          {people_coverage.value === "other" ? (
            <Worksheet.Row label="Who is covered by this plan?" paddedField>
              <Worksheet.Field padded>
                <PeopleCheckboxGroup
                  people={people}
                  ownerId={ownerId}
                  coveredPeople={covered_people}
                />
              </Worksheet.Field>
            </Worksheet.Row>
          ) : null}
        </Worksheet.Row>
        <Worksheet.Row
          label="Is this a high deductible health plan (HDHP) with a Health Savings Account (HSA)?"
          paddedField
        >
          <Worksheet.Field>
            <CheckboxYesNo fluid {...is_hdhp} />
          </Worksheet.Field>
        </Worksheet.Row>
        {is_hdhp.value === "true" ? (
          <Worksheet.RowCollection>
            <Worksheet.Row
              label="How much does your employer contribute to your Health Savings Account each pay period?"
              paddedField
            >
              <Worksheet.Field error={employer_hsa_contribution_amount.error}>
                <LabeledInput
                  {...employer_hsa_contribution_amount}
                  label=""
                  iconText="$"
                  iconPosition="left"
                  placeholder="0"
                />
                <div style={{ fontWeight: "normal" }}>
                  {getAnnualCost(
                    employer_hsa_contribution_amount.value,
                    income_id.value
                  )}
                </div>
              </Worksheet.Field>
            </Worksheet.Row>
            <Worksheet.Row
              label="Select the Health Savings Account (HSA) your employer contributes to"
              paddedField
            >
              <Worksheet.Field error={employer_hsa_contribution_amount.error}>
                <Dropdown
                  placeholder="Health Savings Account"
                  search
                  selection
                  options={hsaAccountOptions}
                  {...hsa_account_id}
                />
              </Worksheet.Field>
            </Worksheet.Row>
          </Worksheet.RowCollection>
        ) : null}
      </Worksheet.Body>
      <Footer
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Health Plan"
        error={error}
      />
    </Worksheet>
  )
}

const ESHCPlanFormContainer = FormContainer(
  {
    income_id: {
      type: "string"
    },
    premium_amount: {
      type: "unit"
    },
    people_coverage: {
      type: "string",
      defaultValue: "individual"
    },
    covered_people: {
      type: "array",
      schema: {
        person_id: {
          type: "string"
        }
      }
    },
    is_hdhp: {
      type: "boolean",
      defaultValue: "false"
    },
    employer_hsa_contribution_amount: {
      type: "unit",
      required: false
    },
    hsa_account_id: {
      type: "string",
      required: false
    }
  },
  (fields, ...form) => {}
)(ESHCPlanForm)

const ESHCPlan = ({ benefit, household, type, ...formProps }) => {
  const [incomes] = useStore("householdIncomes", household.id)
  const [people] = useStore("householdPeople", household.id)
  const [accounts] = useStore("householdAccounts", household.id)
  const [employers] = useStore("householdEmployers", household.id)
  const [benefits, { addBenefit, updateBenefit, deleteBenefit }] = useStore(
    "householdBenefits",
    household.id
  )

  const isNew = benefit === null
  let incomesWithBenefit = Object.values(benefits)
    .filter(({ type: benefitType }) => benefitType === type)
    .map(({ income_id }) => income_id)
  let values = {
    income_id:
      Object.values(incomes).length === 1 ? Object.values(incomes)[0].id : null
  }
  if (!isNew) {
    values = Object.assign({}, benefit)
    incomesWithBenefit = incomesWithBenefit.filter(
      id => id !== values.income_id
    )
  }
  const hasSpouse = Object.values(people).some(({ role }) => role === "spouse")

  const incomeSourceOptions = Object.values(incomes)
    .filter(({ type }) => type === "employment")
    .filter(({ id }) => !incomesWithBenefit.includes(id))
    .map(income => {
      const employer = Object.values(employers).find(
        ({ id }) => id === income.employer_id
      )
      const incomeName = employer ? employer.name : income.description
      const text = hasSpouse
        ? `${incomeName} (${
            people[income.person_id] ? people[income.person_id].first_name : ""
          })`
        : incomeName
      return {
        text,
        value: income.id
      }
    })

  const getAnnualCost = (premium_amount, incomeId) => {
    let annualCostDescription = ""
    if (incomeId && premium_amount) {
      const premiumAmount = parseFloat(premium_amount.replace(",", ""))
      const selectedIncome = Object.values(incomes).find(
        income => income.id === incomeId
      )
      if (selectedIncome) {
        const payFrequency = selectedIncome.pay_frequency
          ? selectedIncome.pay_frequency
          : "monthly"
        const annualCost = premiumAmount * PAY_FREQUENCY_DIVISOR[payFrequency]
        annualCostDescription =
          "$" +
          premiumAmount +
          " " +
          getPeriodDescription(payFrequency) +
          " is " +
          formatCurrency(annualCost) +
          " per year."
      }
    }
    return annualCostDescription
  }
  const submit = isNew
    ? async values =>
        await addBenefit({
          household_id: household.id,
          type,
          ...values,
          people_coverage:
            values.covered_people.length === 0 &&
            values.people_coverage !== "family"
              ? "individual"
              : values.people_coverage
        })
    : async values =>
        await updateBenefit({
          id: benefit.id,
          type,
          ...values,
          people_coverage:
            values.covered_people.length === 0 &&
            values.people_coverage !== "family"
              ? "individual"
              : values.people_coverage
        })

  const onDelete = () =>
    deleteBenefit({
      id: benefit.id,
      household_id: household.id
    })
  return (
    <ESHCPlanFormContainer
      {...{
        isNew,
        submit,
        onDelete,
        incomes: Object.values(incomes),
        accounts: Object.values(accounts),
        people: Object.values(people),
        employers: Object.values(employers),
        incomeSourceOptions,
        getAnnualCost,
        values,
        ...formProps
      }}
    />
  )
}

export default ESHCPlan
